var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHovertestimonials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_805_7486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8574 0.857117H4.28599C3.83133 0.857117 3.3953 1.03773 3.0738 1.35922C2.75232 1.68071 2.57171 2.11674 2.57171 2.5714V18L0.857422 23.1428L7.71456 21.4285H21.4289C21.8835 21.4285 22.3196 21.2479 22.641 20.9264C22.9625 20.605 23.1431 20.1689 23.1431 19.7143V11.1428",
    stroke: "#EFBC51",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3372 13.9488L9.19434 14.8745L10.0515 9.66309L18.1601 1.58881C18.3194 1.42813 18.509 1.3006 18.7179 1.21357C18.9267 1.12653 19.1508 1.08173 19.3773 1.08173C19.6035 1.08173 19.8276 1.12653 20.0364 1.21357C20.2454 1.3006 20.435 1.42813 20.5944 1.58881L22.4115 3.40595C22.5722 3.56531 22.6997 3.75491 22.7868 3.96381C22.8737 4.17272 22.9186 4.39679 22.9186 4.62309C22.9186 4.8494 22.8737 5.07347 22.7868 5.28237C22.6997 5.49128 22.5722 5.68088 22.4115 5.84024L14.3372 13.9488Z",
    stroke: "#EFBC51",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_805_7486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHovertestimonials);
export default __webpack_public_path__ + "static/media/hovertestimonials.354625f5ba8d5a1ecd2ee27dd31ced13.svg";
export { ForwardRef as ReactComponent };